module.exports = __webpack_public_path__ + "static/media/cops.72488190.jpeg";